import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBriefcaseJob = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.01553 7.97382C2.16936 9.48639 3.44684 10.6667 5 10.6667H11C12.5532 10.6667 13.8306 9.48639 13.9845 7.97382M2.01553 7.97382C2 8.32951 2 8.76674 2 9.33333C2 10.5742 2 11.1946 2.16315 11.6967C2.49287 12.7115 3.28848 13.5071 4.30328 13.8369C4.80539 14 5.42581 14 6.66667 14H9.33333C10.5742 14 11.1946 14 11.6967 13.8369C12.7115 13.5071 13.5071 12.7115 13.8369 11.6967C14 11.1946 14 10.5742 14 9.33333C14 8.76674 14 8.3295 13.9845 7.97382M2.01553 7.97382C2.03402 7.55056 2.07449 7.24278 2.16315 6.96994C2.49287 5.95515 3.28848 5.15954 4.30328 4.82981C4.58171 4.73934 4.89652 4.69904 5.33333 4.68109M13.9845 7.97382C13.966 7.55055 13.9255 7.24278 13.8369 6.96994C13.5071 5.95515 12.7115 5.15954 11.6967 4.82981C11.4183 4.73934 11.1035 4.69904 10.6667 4.68109M10.6667 4.68109V4.66667C10.6667 4.04669 10.6667 3.7367 10.5985 3.48236C10.4136 2.79218 9.87449 2.25308 9.1843 2.06815C8.92997 2 8.61998 2 8 2C7.38002 2 7.07003 2 6.8157 2.06815C6.12551 2.25308 5.58642 2.79218 5.40148 3.48236C5.33333 3.7367 5.33333 4.04669 5.33333 4.66667V4.68109M10.6667 4.68109C10.3158 4.66667 9.88611 4.66667 9.33333 4.66667H6.66667C6.1139 4.66667 5.68425 4.66667 5.33333 4.68109M8 10V11.3333",
		stroke: "#71717A",
		strokeWidth: 1.3,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgBriefcaseJob);
export default ForwardRef;
